import React from 'react';
import { QUERY_CLASSE_WITH_NOTE_AND_STUDENTS_ORDERS } from '../../graphql/query/classe/queryClasseWithNoteAndStudentsOrders';
import { useQuery } from '@apollo/client';
import { GetClasseWithNoteAndStudentsOrdersQuery } from '../../graphql/generated/graphql';
import {
  getAmountDedicatedToNgoForClass,
  getAmountDedicatedToNgoForStudent
} from '../../domain/ngo/ngo';
import { MY_ID } from '../../helpers/user/authorization';
import { getNgoInformationsFromQuery } from '../../helpers/transformApiResponse/ong';
import { BackButton } from '../../components/molecules/Buttons/BackButton';
import { HeaderText } from '../../components/atoms/Texts/HeaderText';
import emoji from '../../theme/emoji';
import useStyle from './ngo.style';
import { MyNgoContribution } from '../../components/organisms/Ngo/MyNgoContribution';
import { ClassContribution } from '../../components/organisms/Ngo/ClassContribution';
import useGoToPage from '../../hooks/useGoToPage';
import pages from '../../routes/pages';
import { LoadingContainer } from '../../components/molecules/Loaders/LoadingContainer';
import { ErrorContainer } from '../../components/organisms/Error/ErrorContainer';
export const NGO = () => {
  const classes = useStyle();
  const goToClassPage = useGoToPage(pages.CLASSE_SETTINGS_PAGE.path);
  const { data, loading, error } = useQuery<
    GetClasseWithNoteAndStudentsOrdersQuery
  >(QUERY_CLASSE_WITH_NOTE_AND_STUDENTS_ORDERS, {
    variables: {
      userId: MY_ID
    }
  });

  if (loading) return <LoadingContainer status={loading} />;
  if (error) return <ErrorContainer />;

  const { studentsClass, student } = getNgoInformationsFromQuery(data);
  const classNgoContribution = getAmountDedicatedToNgoForClass(
    studentsClass.caClass,
    studentsClass.orders,
    studentsClass.percentDedicatedToNgo,
    studentsClass.ngo
  );

  const studentNgoContribution = getAmountDedicatedToNgoForStudent(
    student.note.qteca,
    student.ordersWithContribution,
    student.orders,
    student.ngo
  );

  return (
    <div className={classes.root}>
      <BackButton text="Revenir à la page précédente" onClick={goToClassPage} />
      <HeaderText
        text='Contribution "1€" de mes clients'
        emoji={emoji['PalmsUpTogether']}
      />
      <MyNgoContribution
        student={student}
        contribution={studentNgoContribution}
      />
      <HeaderText text="Contribution classe" emoji={emoji['Teacher']} />
      <ClassContribution
        studentsClass={studentsClass}
        contribution={classNgoContribution}
      />
    </div>
  );
};
